// Test IDs for the Agent Dashboard (/agent-dashboard) page.
// Keys are camelCase; values are kebab-case shaped as
// `agent-dashboard-<element>`.

export const AGENT_DASHBOARD = {
        root: 'agent-dashboard-root',
        banner: 'agent-dashboard-banner',
        loading: 'agent-dashboard-loading',
        error: 'agent-dashboard-error',
        refreshButton: 'agent-dashboard-refresh-button',
        cardMarketSignals: 'agent-dashboard-card-market-signals',
        cardOfferBuilder: 'agent-dashboard-card-offer-builder',
        cardYoutubeContent: 'agent-dashboard-card-youtube-content',
        cardLeadMagnet: 'agent-dashboard-card-lead-magnet',
        statusMarketSignals: 'agent-dashboard-status-market-signals',
        statusOfferBuilder: 'agent-dashboard-status-offer-builder',
        statusYoutubeContent: 'agent-dashboard-status-youtube-content',
        statusLeadMagnet: 'agent-dashboard-status-lead-magnet',
        generatedAtMarketSignals: 'agent-dashboard-generated-at-market-signals',
        generatedAtOfferBuilder: 'agent-dashboard-generated-at-offer-builder',
        generatedAtYoutubeContent: 'agent-dashboard-generated-at-youtube-content',
        generatedAtLeadMagnet: 'agent-dashboard-generated-at-lead-magnet',
        headlineMarketSignals: 'agent-dashboard-headline-market-signals',
        headlineOfferBuilder: 'agent-dashboard-headline-offer-builder',
        headlineYoutubeContent: 'agent-dashboard-headline-youtube-content',
        headlineLeadMagnet: 'agent-dashboard-headline-lead-magnet',
        attributionSection: 'agent-dashboard-attribution-section',
        attributionLoading: 'agent-dashboard-attribution-loading',
        attributionError: 'agent-dashboard-attribution-error',
        attributionCardMarketSignals: 'agent-dashboard-attribution-card-market-signals',
        attributionCardOfferBuilder: 'agent-dashboard-attribution-card-offer-builder',
        attributionCardYoutubeContent: 'agent-dashboard-attribution-card-youtube-content',
        attributionCardLeadMagnet: 'agent-dashboard-attribution-card-lead-magnet',
        attributionClicksMarketSignals: 'agent-dashboard-attribution-clicks-market-signals',
        attributionClicksOfferBuilder: 'agent-dashboard-attribution-clicks-offer-builder',
        attributionClicksYoutubeContent: 'agent-dashboard-attribution-clicks-youtube-content',
        attributionClicksLeadMagnet: 'agent-dashboard-attribution-clicks-lead-magnet',
        attributionConversionsMarketSignals: 'agent-dashboard-attribution-conversions-market-signals',
        attributionConversionsOfferBuilder: 'agent-dashboard-attribution-conversions-offer-builder',
        attributionConversionsYoutubeContent: 'agent-dashboard-attribution-conversions-youtube-content',
        attributionConversionsLeadMagnet: 'agent-dashboard-attribution-conversions-lead-magnet',
        attributionRateMarketSignals: 'agent-dashboard-attribution-rate-market-signals',
        attributionRateOfferBuilder: 'agent-dashboard-attribution-rate-offer-builder',
        attributionRateYoutubeContent: 'agent-dashboard-attribution-rate-youtube-content',
        attributionRateLeadMagnet: 'agent-dashboard-attribution-rate-lead-magnet',
        attributionRevenueMarketSignals: 'agent-dashboard-attribution-revenue-market-signals',
        attributionRevenueOfferBuilder: 'agent-dashboard-attribution-revenue-offer-builder',
        attributionRevenueYoutubeContent: 'agent-dashboard-attribution-revenue-youtube-content',
        attributionRevenueLeadMagnet: 'agent-dashboard-attribution-revenue-lead-magnet',
};
